import { render, staticRenderFns } from "./ToolSearch.vue?vue&type=template&id=ed838a8c"
import script from "./ToolSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToolSearch.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports